import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-text-counter',
  templateUrl: './text-counter.component.html',
  standalone: false
})
export class TextCounterComponent {
  private _text: string
  private _maxLength: number

  @Input()
  set text(value: string) {
    this._text = value || ''
  }
  get text(): string {
    return this._text
  }
  @Input()
  set maxLength(value: number) {
    this._maxLength = Number(value) ? value : 0
  }
  get maxLength(): number {
    return this._maxLength
  }
}
